import {
  uploadVideoLink,
  deleteVideoLinkApi,
  fetchVideoLink,
} from 'api/video';

import {
  SAVE_VIDEO_LINK,
  UPLOAD_VIDEO_LINK,
  UPDATE_HAS_SNACK_BAR,
  DELETE_VIDEO_LINK,
  FETCH_VIDEO_LINK,
} from './types';

export const saveVideoLinkAction = (url) => ({
  type: SAVE_VIDEO_LINK,
  extraProperties: { url },
});

export const uploadVideoLinkAction = (houseType, houseId, url, videoSource) => ({
  type: UPLOAD_VIDEO_LINK,
  promise: uploadVideoLink(houseType, houseId, url, videoSource),
});

export const updateHasSnackBarAction = (state) => ({
  type: UPDATE_HAS_SNACK_BAR,
  extraProperties: { state },
});

export const deleteVideoLinkAction = (id) => ({
  type: DELETE_VIDEO_LINK,
  promise: deleteVideoLinkApi(id),
});

export const fetchVideoLinkAction = (houseType, houseId) => ({
  type: FETCH_VIDEO_LINK,
  promise: fetchVideoLink(houseType, houseId),
});
